export default __webpack_public_path__ + "static/media/eyes.22ed3624.svg";